export const useTestId = (props: any, defaultTestId: string) => {
  const prefix = props['data-testid'] ?? defaultTestId;

  const formTestIdAttr = (childName?: string, convertAttrToClassName?: boolean) => {
    if (!useTestId.addTestId) return {};

    childName = childName ? `.${childName}` : '';
    const attrValue = `${prefix}${childName}`;
    if (convertAttrToClassName) {
      return {
        className: `${props.className ?? ''} data-testid_${attrValue.replaceAll(/[!"#$%&'()*+,/:;<=>?@[\\\]^`{|}~]/g, '').replaceAll(/[ .]/g, '_')}`.trim()
      };
    }

    return { 'data-testid': `${attrValue}` };
  };

  const generateTestId = (childName?: string) => formTestIdAttr(childName);
  const generateTestIdClassName = (childName?: string) => formTestIdAttr(childName, true);

  return { generateTestId, generateTestIdClassName };
};

useTestId.addTestId = true;
